export default __webpack_public_path__ + "static/media/zanocuj.e041653a.png";